import { Routes } from '@angular/router';
import { SignInComponent } from './sign-in/sign-in.component';
import { ContactUsFormComponent } from './contact/contact-us/contact-us-form.component';
import { ForgotPasswordFormComponent } from './forgot-password/forgot-password-form.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import { SsoLandingComponent } from './sso-landing/sso-landing.component';
import { UnauthorisedComponent } from '../error-pages/unauthorised/unauthorised.component';

export const authenticationRoutes: Routes = [
    {
        path: '403',
        component: UnauthorisedComponent
    },
    {
        path: 'sign-in',
        component: SignInComponent,
        outlet: 'top'
    },
    {
        path: 'sso-auth',
        component: SsoLandingComponent,
        outlet: 'top'
    },
    {
        path: 'contact-us',
        component: ContactUsFormComponent,
        outlet: 'top'
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordFormComponent,
        outlet: 'top'
    },
    {
        path: 'forgotten-password/:linkTypeId/:linkId',
        component: UpdatePasswordComponent,
        outlet: 'top'
    }
];
